import React, { useEffect } from 'react';
import './Rangeofproducts.css';

const RangeOfProducts = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const products = [
    { icon: '💱', name: 'Forex CFDs', count: '61 Currency Pairs', features: ['Major pairs: EUR/USD, GBP/USD', 'Minor pairs: EUR/GBP, AUD/NZD', 'Leverage up to 1:1000'] },
    { icon: '📊', name: 'Stock CFDs', count: '+2100 Products', features: ['US stocks: Apple, Microsoft', 'European stocks: Volkswagen', 'Asian stocks: Toyota, Alibaba'] },
    { icon: '📈', name: 'Index CFDs', count: '25 Indices', features: ['US: S&P 500, NASDAQ', 'Europe: DAX, FTSE 100', 'Asia: Nikkei 225'] },
    { icon: '🛢️', name: 'Commodities', count: '24 Products', features: ['Energy: Oil, Natural Gas', 'Metals: Gold, Silver', 'Agriculture: Wheat, Corn'] },
    { icon: '💎', name: 'Cryptocurrency', count: '21 Products', features: ['Bitcoin, Ethereum', '24/7 trading', 'No crypto wallet needed'] },
    { icon: '📋', name: 'Bond CFDs', count: '9 Products', features: ['US Treasury bonds', 'German Bunds', 'UK Gilts'] }
  ];

  return (
    <div className="page-container">
      <div className="container">
        <button className="back-button" onClick={() => window.history.back()}>
          <span>←</span><span>Back to Home</span>
        </button>

        <h1>Range of Products</h1>
        <p className="subtitle">Trade over 2,000 instruments across multiple asset classes.</p>

        <div className="products-grid">
          {products.map((product, index) => (
            <div key={index} className="product-card">
              <div className="product-icon">{product.icon}</div>
              <h3>{product.name}</h3>
              <div className="product-count">{product.count}</div>
              <ul className="features-list">
                {product.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RangeOfProducts;